// extracted by mini-css-extract-plugin
export default {"container":"style-module__container___VLdHS","list":"style-module__list___kDckv","item":"style-module__item___KidUW"};